import { render, staticRenderFns } from "./Collect4.vue?vue&type=template&id=5861e295&scoped=true&lang=pug&"
import script from "./Collect4.vue?vue&type=script&lang=ts&"
export * from "./Collect4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861e295",
  null
  
)

export default component.exports